import React, { useEffect } from 'react';
import { Nav, NavItem } from '../../compat/BootstrapCompat';
import PropTypes from 'prop-types';

import Banner from '../reusable/Banner';
import BannerMobile from '../reusable/BannerMobile';

import { checkProductCoupon, fixBanner } from '../../../../services/v2/productsService';

import './ProductPackage.css'

/**
 * ProductPackage.
 * Page for product.
 *
 * @author  Manny
 * @param   {String}      props.activeKey       Coupon object.
 * @param   {String}      props.coupon          Coupon object.
 * @param   {String}      props.method          Id number of the product.
 * @param   {Function}    props.onSelectPackage Handles onClick for selecting a package.
 * @param   {String}      props.packageKey      Name of the package.
 * @param   {Object}      props.productPackage  The product package.
 * @param   {Object}      props.productsConfig  Product configurations.
 * @param   {Function}    props.setActiveKey    Sets active key.
 * @param   {Function}    props.setPackageKey   Sets package key.
 * @returns {JSX.Element} The component markup.
 */

const ProductPackage = ({
  activeKey,
  coupon,
  method,
  onSelectPackage,
  packageKey,
  productPackage,
  productsConfig,
  setActiveKey,
  setPackageKey
}) => {
  useEffect(() => {
    window.addEventListener('scroll', fixBanner);

    return () => {
      window.removeEventListener('scroll', fixBanner);
    };
  }, []);

  const {
    contactText,
    contactUrl,
    packageHeader,
    packageTexts,
    packageTitle,
    productId,
    productName
  } = productPackage;

  const isMobile = /Android|webOS|iPhone|iPod|ipad|BlackBerry/i.test(navigator.userAgent);

  let classNames = require('classnames');

  const containerClass = classNames({
    'col-sm-12': isMobile === false,
    'col-sm-12 no-padding': isMobile === true
  });

  const changePackage = (newActiveKey, newPackageKey) => {
    setActiveKey(newActiveKey);
    setPackageKey(newPackageKey);
  };

  useEffect(() => {
    if (productsConfig) {
      if (Object.keys(productsConfig.packages).length === 1) {
        setPackageKey(
          Object.keys(productsConfig.packages)[Object.keys(productsConfig.packages).length - 1]
        );
        setActiveKey(Object.keys(productsConfig.packages).length);
      }
    }
  }, [productsConfig]);

  const renderPackageTexts = (texts) => {
    return texts?.map((packageText, index) => {
      return (
        <p
          id={`package_text_${index}`}
          key={packageText}
          className='product-adv-text'
        >
          {packageText}
        </p>
      );
    })
  }

  return (
    <React.Fragment>
      {productsConfig && (
        <div>
          <div className='row no-margin'>
            <div className='col-sm-12'>
              <div className='row no-margin'>
                <div
                  className='col-sm-12 section-title heading1 text-center'
                  id='package_header'
                  style={{ paddingBottom: '20px' }}
                >
                  {packageHeader}
                </div>
              </div>
              <div className='row no-margin'>
                <div className={containerClass}>
                  {coupon &&
                    Object.keys(coupon).length > 0 &&
                    checkProductCoupon(productId, coupon.productIds) &&
                    coupon.blueBoxText !== null && (
                      <div className='row no-margin page-dim padded-sides'>
                        <div className='col-sm-12 discount-alert blue-bg no-margin captions-semibold'>
                          <span>{coupon.blueBoxText}</span>
                        </div>
                      </div>
                  )}

                  {isMobile &&
                    coupon &&
                    Object.keys(coupon).length > 0 &&
                    checkProductCoupon(productId, coupon.productIds) &&
                    coupon.blueBoxText !== null && <br />}

                  {isMobile === false && (
                    <div className='row no-margin margin-bottom-100 page-dim white-bg'>
                      <div className='col-xs-12 panel-container'>
                        <Banner
                          industryPackage={productsConfig}
                          onSelectPackage={onSelectPackage}
                          product={productName}
                          buyNow={method ? method.includes('buyNow') : false}
                        />
                        {(packageTitle || packageTexts || contactText) && (
                          <div
                            className='row light-blue-bg padding-15 vertical-align'
                            style={{ margin: '15px 0px 0px 0px' }}
                          >
                            <div
                              className='col-sm-2'
                            />
                            <div
                              className='col-sm-6'
                              style={{marginLeft: '60px'}}
                            >
                              <div id='package_title' className='package-table-title'>
                                {packageTitle}
                              </div>
                              {renderPackageTexts(packageTexts)}
                            </div>
                            {contactText && (
                              <div
                                x-ms-format-detection='none'
                                className='col-sm-2 heading1 clear-text-deco contact-text'
                                style={{ paddingLeft: '0' }}
                              >
                                <a
                                  id='contact-btn'
                                  type='button'
                                  className='btn package-btn'
                                  href={contactUrl}
                                >
                                  {contactText}
                                </a>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {isMobile === true && (
                    <div className='row no-margin margin-bottom-100'>
                      <div className='col-xs-12 white-bg padding-bottom-15'>
                        <div className='row off-white-bg'>
                          <div className='font-14 text-center'>
                            {productsConfig.packages[packageKey].short_description ||
                              productsConfig.packages[packageKey].description}
                          </div>
                          <br />
                        </div>
                        <div className='row'>
                          <Nav bsStyle='tabs' id='commercial-nav-tabs' activeKey={activeKey}>
                            {Object.keys(productsConfig.packages).map(function (
                              singlePackage,
                              index
                            ) {
                              let item = productsConfig.packages[singlePackage];
                              let counter = index + 1;
                              counter = counter.toString();
                              if (
                                (method
                                  ? method.includes('buyNow')
                                  : item.key === 'trial') ||
                                item.visible === false
                              ) {
                                return <div key={counter}></div>;
                              } else {
                                return (
                                  <NavItem
                                    eventKey={counter}
                                    onClick={() => {
                                      changePackage(counter, item.key);
                                    }}
                                    key={counter}
                                  >
                                    {item.title}
                                  </NavItem>
                                );
                              }
                            })}
                          </Nav>
                          <BannerMobile
                            industryPackage={productsConfig}
                            onSelectPackage={onSelectPackage}
                            packageKey={packageKey}
                            packages={productsConfig.packages}
                            product={productName}
                          />
                        </div>
                        {(packageTitle || packageTexts || contactText) && (
                          <div
                            className='row light-blue-bg padding-15 vertical-align'
                            style={{ margin: '15px 0px 0px 0px' }}
                          >
                            <div
                              className='col-sm-8 text-left'
                              style={{ borderBottom: '1px solid #ccc', paddingBottom: '10px' }}
                            >
                              <div id='package_title' className='package-table-title'>
                                {packageTitle}
                              </div>
                              {renderPackageTexts(packageTexts)}
                            </div>
                            <div
                              x-ms-format-detection='none'
                              className='col-sm-4 heading1 margin-top-10 text-center'
                            >
                              <a
                                id='contact-btn'
                                type='button'
                                className='btn package-btn'
                                href={contactUrl}
                              >
                                {contactText}
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {!productsConfig && (
        <div className='row spinner'>
          <i className='fa fa-spinner fa-pulse fa-3x fa-fw'></i>
          <span className='sr-only'>Loading...</span>
        </div>
      )}
    </React.Fragment>
  );
};

ProductPackage.propTypes = {
  activeKey: PropTypes.string.isRequired,
  coupon: PropTypes.string,
  method: PropTypes.string,
  onSelectPackage: PropTypes.func.isRequired,
  packageKey: PropTypes.string.isRequired,
  productPackage: PropTypes.object.isRequired,
  productsConfig: PropTypes.object,
  setActiveKey: PropTypes.func.isRequired,
  setPackageKey: PropTypes.func.isRequired
};

export default ProductPackage;
